import { routePaths } from 'constants/routes';
import { Switch, Redirect } from 'react-router-dom';
import { PrivateRoute as Route } from './PrivateRoute';
import { mainRoutes } from './routes';

export const MainRoutes = (): JSX.Element => {
  return (
    <Switch>
      {mainRoutes.map((route, index) => (
        <Route key={`route-${index}`} {...route} />
      ))}

      <Redirect to={routePaths.login} />
    </Switch>
  );
};
